module.exports = __webpack_public_path__ + "media/reskin-images/icon--behaviors-7c86bb10.svg";